<template>
    <div class="box" v-if="item">
        <article class="media">
            <figure class="media-left" v-if="image">
                <p class="image is-64x64">
                    <img :src="image.url" alt="">
                </p>
            </figure>
            <div class="media-content">
                <div class="content">
                    <p>
                        <strong>{{ item.model }}</strong><br/>
                        <small v-if="item.type.key !== 'service'">
                            <strong>På lager:</strong> <small v-html="item.stock_count_total"/>
                            <br/>
                        </small>
                        <small v-if="item.type.key !== 'service'">
                            <strong>Vægt:</strong> <small v-html="item.weight_display"/>
                            <br/>
                        </small>
<!--                        <small>-->
<!--                            <strong>Rabat:</strong> <small v-html="item.max_discount_display"/>-->
<!--                            <br/>-->
<!--                        </small>-->
                        <small v-if="item.type.key !== 'service'">
                            <strong>Toldkode:</strong> <small v-html="item.customs_code"/>
                            <br/>
                        </small>
                        <small>
                            <strong>Beskrivelse (DA):</strong><br /><small v-html="item.description_da"/>
                            <br/>
                        </small>
                        <small>
                            <strong>Beskrivelse (EN):</strong><br /><small v-html="item.description_en"/>
                        </small>
                    </p>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            required: true
        },
    },
    computed: {
        image() {
            if (this.item.images.length > 0) {
                return this.item.images[0];
            }

            if (this.item.manufacturer.logo) {
                return {
                    url: this.item.manufacturer.logo,
                }
            }

            return null;
        }
    }
}
</script>

<style scoped lang="scss">
.box {
    //padding: 5px;
    font-size: 20px;
}
</style>
